// Direct account bookmarks follow the same native sign-in flow as the header.
// Liquid renders only the sign-in fallback for guests, including without JavaScript.
const loginLink = document.querySelector('[data-account-login]');
if (loginLink) window.location.replace(loginLink.href);
